import { render } from "./index.vue?vue&type=template&id=752b3b1d&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=752b3b1d&lang=less&scoped=true"
import "./index.vue?vue&type=style&index=1&id=752b3b1d&lang=less"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-752b3b1d"]])

export default __exports__